export default __webpack_public_path__ + "static/media/add.3cb51f5e.svg";